const pagingParams = (page = 1, perPage = 25) => ({
  page,
  per_page: perPage,
});

export default pagingParams;
